module.exports = __webpack_public_path__ + "static/csdb-twitter-29ce0ba49db4d298d2edeb2b95a5db79.png";